

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { PaymentDetails } from 'src/app/model/ngrx/payment-details.model';

export const ADD_PAYMENT_DETAILS = '[PAYMENTDETAIL] Add';
export const REMOVE_PAYMENT_DETAILS = '[PAYMENTDETAIL] Remove';

// AddPersonalDetails
export class AddPaymentDetails implements Action {
    readonly type = ADD_PAYMENT_DETAILS;

    constructor(public payload: PaymentDetails) { }
}
// RemovePersonalDetails
export class RemovePaymentDetails implements Action {
    readonly type = REMOVE_PAYMENT_DETAILS;

    constructor(public payload: number) { }
}

export type Actions = AddPaymentDetails | RemovePaymentDetails;
